// export const apiUrl = 'http://localhost:3000/admin';
// export const apiUrl = 'https://cocoon-staging-bit.herokuapp.com/admin';
export const apiUrl = 'https://api.cocoon.club/admin';
export const loginUrl = `${apiUrl}/login`;
export const authUrl = `${apiUrl}/users/validate`;
